import {
  KUSTOMER_APP_CHAT_MESSAGE_RECEIVE_EVENT,
  KUSTOMER_APP_CHAT_MESSAGE_SEND_EVENT,
  KUSTOMER_APP_CHAT_CSAT_SEND_EVENT,
  KUSTOMER_APP_CHAT_CSAT_SUBMIT_EVENT,
} from 'core_main/pubnub/constants';

import {
  SatisfactionCallbackResponse,
  SatisfactionForm,
  SatisfactionResponse,
} from 'core_main/api/satisfaction/types';
import { createSatisfactionCallbackResponse } from 'core_main/api/satisfaction/helpers';
import { ChatMessagesData } from 'core_main/api/messages/types';
import { createMessageCallbackResponse } from '../send_message/helpers';
import { GetMessagesCallbackResponse, PNMessagesListMessage } from './types';
import { MessageCallbackResponse } from '../send_message/types';

export const createGetMessagesCallbackResponse = (
  pubnubMessages: PNMessagesListMessage[] | undefined,
  sessionId,
): GetMessagesCallbackResponse => {
  let history = {
    satisfaction: {} as SatisfactionCallbackResponse,
    messages: [] as MessageCallbackResponse[],
  };

  if (pubnubMessages?.length) {
    history = pubnubMessages.reduce((acc, data) => {
      if (
        data.message.name === KUSTOMER_APP_CHAT_MESSAGE_RECEIVE_EVENT ||
        data.message.name === KUSTOMER_APP_CHAT_MESSAGE_SEND_EVENT
      ) {
        acc.messages.push(
          createMessageCallbackResponse(
            data.message.data as ChatMessagesData,
            data?.attachments?.data,
            data?.message?.included,
            'pubnub',
          ),
        );
      }

      if (
        data.message.name === KUSTOMER_APP_CHAT_CSAT_SEND_EVENT ||
        data.message.eventType === KUSTOMER_APP_CHAT_CSAT_SUBMIT_EVENT
      ) {
        const form = data?.message.included?.find(
          (entity) => entity.type === 'satisfaction',
        ) as SatisfactionForm;
        const { timetoken } = data;
        acc.satisfaction = createSatisfactionCallbackResponse(
          data?.message?.data as SatisfactionResponse,
          timetoken,
          form,
        );
      }

      return acc;
    }, history);
  }

  return {
    conversationId: sessionId,
    ...history,
  };
};
